import { NotificationsService } from '@services/NotificationsService';
import { RemindersService } from '@services/RemindersService';
import { sendNotification } from '@srm/ui/lib/notifications';
import { formatSnoozeTarget } from '@utils/snoozePresets';

/**
 * Отложить уведомление до даты: создать напоминание (привязанное к связанному документу,
 * если он есть), пометить уведомление прочитанным и показать тост-подтверждение. Общая логика
 * пресетов «Отложить» для превью-тоста, дропдауна и карточки уведомления.
 *
 * @param notificationId ключ уведомления
 * @param message текст напоминания (тема уведомления)
 * @param date целевые дата/время напоминания
 */
export async function snoozeNotificationToReminder(notificationId: string, message: string, date: Date): Promise<void> {
    let docId: number | undefined;
    try {
        const res = await NotificationsService.getBoundDocumentKey(notificationId);
        const numeric = Number(res.data);
        if (res.data && !Number.isNaN(numeric)) docId = numeric;
    } catch {
        // нет связанного документа — создаём самостоятельное напоминание
    }
    await RemindersService.addOrUpdateReminderFromCalendar({ docId, message, date });
    sendNotification({ title: 'Уведомление отложено', message: `Напомним ${formatSnoozeTarget(date)}`, variant: 'green' });
    await NotificationsService.markAsRead([notificationId]);
}
